import React from "react";


import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";

import 'react-tiny-fab/dist/styles.css';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import {

  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,

} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight, FaCheckCircle, FaTimesCircle, FaReceipt } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import CardBox from "../../../components/CardBox";
import * as XLSX from "xlsx";

const StaffAttendanceDetails = (props) => {
  const history = useHistory();

  // Normalize incoming data from route or direct prop
  const routeState = props.location && props.location.state;
  const rawDetails = routeState?.data || props.details || routeState || {};

  const staff = rawDetails.staff || rawDetails.data?.staff || {};
  const passedMonth = rawDetails.month || rawDetails.data?.month || null;
  const passedYear = rawDetails.year || rawDetails.data?.year || null;
  const selectedDate = rawDetails.date || rawDetails.data?.date || null;

  // Backend expects the internal staff primary key (`id`) rather than the display code (`staff_id`)
  const staffId = staff.id || staff.staff_id || null;

  // For display: show either specific date or month/year
  let periodLabel = "";
  if (selectedDate) {
    periodLabel = `Date: ${selectedDate}`;
  } else if (passedMonth && passedYear) {
    const monthName = new Date(passedYear, passedMonth - 1, 1).toLocaleString("default", {
      month: "long",
      year: "numeric",
    });
    periodLabel = `Month: ${monthName}`;
  }

  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);

  const [status, setstatus] = useState('')
  const [saveStatus, setSavestatus] = useState(null)

  const [payroll_tracks, setpayroll_tracks] = useState([])
  const [selected_track_id, setSelected_track_id] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [showModal, setshowModal] = useState(false)
  const [selected_payroll, setselected_payroll] = useState(null)



  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);

  useEffect(() => {
    listAttendanceSummary();

    return () => { };
  }, []);


  const listAttendanceSummary = () => {
    setIsLoading(true);
    genericPost(ENDPOINTS.STAFF_ATTENDANCE_DETAILS, {
      month: passedMonth,
      year: passedYear,
      staff_id: staffId,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setRowData(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const handleGenereateTs = (data) => {

  }

  const handleExportToExcel = () => {
    if (!rowData || rowData.length === 0) {
      cogoToast.error("No attendance data to export", { hideAfter: 3 });
      return;
    }

    try {
      const exportData = rowData.map((row, index) => ({
        "#": index + 1,
        Date: row.date || "",
        "Started At": row.started_at || "",
        "Ended At": row.ended_at || "",
        "Hours Worked": row.hours_worked || "",
        "Lateness Hours": row.lateness_hours || "",
        "Overtime Hours": row.overtime_hours || "",
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Attendance Details");

      const baseName = staff?.staff_name || staff?.staff_id || "Staff";
      const safeName = String(baseName).replace(/[^a-z0-9]/gi, "_");
      const fileName = `${safeName}_Attendance_Details_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (e) {
      console.error("Excel export error", e);
      cogoToast.error("Failed to export attendance to Excel.", { hideAfter: 5 });
    }
  };

  return (
    <div className="container-fluid">
      <Loader loading={isLoading} />
      <div className="row card d-print-block">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3 d-print-none">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => history.goBack()}
            >
              Back
            </button>
            <button
              className="btn btn-outline-success btn-sm"
              onClick={handleExportToExcel}
              disabled={isLoading || rowData.length === 0}
            >
              Export to Excel
            </button>
          </div>

          <div className="col-md-12 mb-3 text-center">
            <h2 className="text-uppercase mb-1">
              {staff?.staff_name || ""} {staffId ? `| ${staffId}` : ""}
            </h2>
            {periodLabel && (
              <div style={{ fontSize: "0.95rem", color: "#6c757d" }}>
                {periodLabel}
              </div>
            )}
          </div>

          <div className="row col-md-12 mb-3">
            <div className="col-md-5">
              <span className="text-muted font-weight-bold">Email:</span>
              <span className="text-primary">
                {" "}
                {staff?.email ? staff.email : ""}
              </span>
            </div>
            <div className="col-md-3">
              <span className="text-muted font-weight-bold">Office:</span>
              <span className="text-primary">
                {" "}
                {staff?.office ? staff.office : ""}
              </span>
            </div>
            <div className="col-md-4">
              <span className="text-muted font-weight-bold">Role:</span>
              <span className="text-primary">
                {" "}
                {staff?.designation ? staff.designation : ""}
              </span>
            </div>
          </div>

          <div className="row col-md-12">
            <div className="col-md-3 mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted font-weight-bold">
                  Attended Days:
                </span>
                <span className="text-primary">
                  {staff?.total_attended_days || 0}
                </span>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted font-weight-bold">
                  Annual Leave Days:
                </span>
                <span className="text-primary">
                  {staff?.annual_leave_days || 0}
                </span>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted font-weight-bold">Sick Leave:</span>
                <span className="text-primary">
                  {staff?.sick_leave_days || 0}
                </span>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted font-weight-bold">Holidays:</span>
                <span className="text-primary">
                  {staff?.holiday_days || 0}
                </span>
              </div>
            </div>
          </div>

          <div className="row col-md-12">
            <div className="col-md-3 mb-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted font-weight-bold">
                  Salary Budgetlines:
                </span>
                <span className="text-primary">
                  {Array.isArray(staff?.budgetlines) &&
                  staff.budgetlines.length > 0 &&
                  staff.budgetlines[0]?.budget
                    ? staff.budgetlines[0].budget.budget_line
                    : ""}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ag-theme-alpine">
        <div className="row col-md-12">
          <div className="col-md-6">  <h4 className="float-start">ATTTENDANCE SUMMARY</h4>
          </div>  <div className="col-md-6">
            
             {/* <button
            type="button"
            className="btn btn-primary float-end"
            onClick={handleGenereateTs}
          >
            <FaReceipt style={{ color: "blue", cursor: "pointer" }} /> &nbsp; Generate Timesheet
          </button> */}
          
          
          </div>
        </div>
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          onRowSelected={(e) => {
            if (e.data?.staff_id != null) {
              //calculate_tests();
            } else {

              return;
            }
          }}
          onSelectionChanged={(e) => {
            if (e.data?.staff != null) {
              //calculate_tests();
            }
          }}

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            //  params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },



            {
              headerName: "Date",
              field: "date",
              sortable: true,
              filter: true,
              minWidth: 120,
            },
            {
              headerName: "Started At",
              field: "started_at",
              sortable: true,
              filter: true,
              minWidth: 120,
            }, {
              headerName: "Ended At",
              field: "ended_at",
              sortable: true,
              filter: true,
              minWidth: 120,
            }, {
              headerName: "Hours Worked",
              field: "hours_worked",
              sortable: true,
              filter: true,
              minWidth: 120,
            },
            {
              headerName: "Lateness Hours",
              field: "lateness_hours",
              sortable: true,
              filter: true,
              minWidth: 120,
            }, {
              headerName: "Overtime Hours",
              field: "overtime_hours",
              sortable: true,
              filter: true,
              minWidth: 130,
            }



          ]}
        ></AgGridReact>
      </div>{" "}

      <hr />




    </div>



  );
};

export default StaffAttendanceDetails;



